<template>
    <div class="map" ref="chooseAddressMap"></div>
</template>

<script>
//高德异步加载器
import AMapLoader from "@amap/amap-jsapi-loader";
import { Toast } from 'mint-ui';
export default {
    data() {
        return {
            AMap: null,
            map: null,
            geocoder: null
        };
    },
    mounted() {
        AMapLoader.load({
            key: this.amapKey, // 申请好的Web端开发者Key，首次调用 load 时必填
            version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            plugins: ["AMap.Geolocation", "AMap.Geocoder"] //插件列表
        }).then(AMap => {
                this.AMap = AMap;
                this.map = new AMap.Map(this.$refs.chooseAddressMap, {
                    zoom: 12
                });
                this.geocoder = new AMap.Geocoder({
                    city: "全国"
                });
                this.map.on("touchend", e => {
                    this.getAddress(e.lnglat);
                });

                const geolocation = new AMap.Geolocation({
                    timeout: 10000,
                    // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
                    buttonOffset: new AMap.Pixel(10, 20),
                    //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                    zoomToAccuracy: true,
                    //  定位按钮的排放位置,  RB表示右下
                    buttonPosition: "RB",
                    needAddress: true
                });

                geolocation.getCurrentPosition((status, result) => {
                    if (status == "complete") {
                        this.map.setCenter(result.position, true);
                        this.getAddress(result.position);
                    } else if(!this._isDestroyed){
                        Toast({
                            message: '定位失败',
                            position: 'bottom',
                            duration: 3000
                        });
                    }
                });
            }).catch(e => {
                console.log(e);
            });
    },

    methods: {
        getAddress(lnglat) {
            this.geocoder.getAddress(lnglat, (status, result) => {
                if (status === "complete" && result.info === "OK") {
                    const address = result.regeocode.formattedAddress;
                    this.$emit("change-address", address);
                }
            });
        }
    }
};
</script>

<style scoped>
.map {
    flex: 1;
}
</style>